import { render, staticRenderFns } from "./DastBanner.vue?vue&type=template&id=1b42788a&scoped=true"
import script from "./DastBanner.vue?vue&type=script&lang=js"
export * from "./DastBanner.vue?vue&type=script&lang=js"
import style0 from "./DastBanner.vue?vue&type=style&index=0&id=1b42788a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42788a",
  null
  
)

export default component.exports